var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.148 14.148"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31473",
    d: "M2.304 14.148h9.54a2.04 2.04 0 002.3-2.281V2.289a2.043 2.043 0 00-2.3-2.286h-9.54a2.04 2.04 0 00-2.3 2.289v9.575a2.037 2.037 0 002.3 2.281zm.016-.969a1.214 1.214 0 01-1.351-1.367V2.335A1.218 1.218 0 012.321.968h9.5a1.227 1.227 0 011.359 1.367v9.477a1.223 1.223 0 01-1.36 1.368zM7.086 3.133a.443.443 0 00-.461.461v4.531l.049 1.437-.862-.959-1.125-1.134a.448.448 0 00-.328-.133.425.425 0 00-.437.43.424.424 0 00.125.32l2.687 2.68a.474.474 0 00.352.172.474.474 0 00.352-.172l2.688-2.68a.455.455 0 00.125-.32.425.425 0 00-.437-.43.448.448 0 00-.328.133L8.367 8.603l-.875.969.047-1.447V3.594a.437.437 0 00-.453-.461z",
    fill: "inherit"
  })));
}

export default SvgDownload;